var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeThRow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "#68688a",
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 104.232 297.284 C 56.255 297.284 26.272 349.22 50.257 390.77 C 61.391 410.054 81.964 421.931 104.232 421.931 L 395.073 421.931 C 443.048 421.931 473.034 369.995 449.044 328.446 C 437.911 309.164 417.338 297.284 395.073 297.284 L 104.232 297.284 Z M 104.232 255.736 L 395.073 255.736 C 475.033 255.736 525.007 342.297 485.028 411.544 C 466.472 443.681 432.181 463.48 395.073 463.48 L 104.232 463.48 C 24.271 463.48 -25.705 376.92 14.277 307.672 C 32.831 275.534 67.121 255.736 104.232 255.736 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 54.017 303.94 L 344.858 303.94 C 424.818 303.94 474.792 390.501 434.813 459.748 C 416.257 491.885 381.966 511.684 344.858 511.684 L 54.017 511.684 C -25.944 511.684 -75.92 425.124 -35.938 355.876 C -17.384 323.738 16.906 303.94 54.017 303.94 Z",
    style: {},
    transform: "matrix(1, 0, 0, 1, 50.45126, -262.144928)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeThRow);
export default __webpack_public_path__ + "static/media/change_th_row.3c773320e07946452e9fc67a25a28684.svg";
export { ForwardRef as ReactComponent };